export default __webpack_public_path__ + "static/app-landing-page-1-df9d5f13404533c9ab084270bef8d958.png";